module.exports = __webpack_public_path__ + "files/f76636867fa5891696b9ee4c18e484e7.png";